import { routerBasePath } from "@/config/deployBase";

export function getBasePath() {
  return routerBasePath;
}

export function getRoutePrefix() {
  // Import getDistributer dynamically to avoid circular dependencies
  const { getDistributer } = require('./common');
  const distributer = getDistributer();
  return distributer?.distributerID === "NOARC" ? "" : "/#";
}

export function buildRouteUrl(path) {
  const basePath = getBasePath();
  const routePrefix = getRoutePrefix();
  const origin = window.location.origin;

  // Remove leading slash from path if present
  const cleanPath = path.startsWith('/') ? path.substring(1) : path;

  // If NOARC, don't use hash prefix (history mode)
  const { getDistributer } = require('./common');
  const distributer = getDistributer();
  if (distributer?.distributerID === "NOARC") {
    return `${origin}${basePath}${cleanPath}`;
  }

  // For hash mode: /motor/#/route or /#/route (depending on basePath)
  // basePath can be "/motor/" (ends with /) or "/" (root)
  // routePrefix is "/#" (starts with /)
  // We need to avoid double slashes
  if (basePath === '/') {
    // Root path: /#/route
    return `${origin}${routePrefix}/${cleanPath}`;
  }
  // Base path like "/motor/": remove trailing slash to avoid /motor//#
  const basePathTrimmed = basePath.endsWith('/') ? basePath.slice(0, -1) : basePath;
  return `${origin}${basePathTrimmed}${routePrefix}/${cleanPath}`;
}

function readEnvLogoutUrl(isB2c) {
  const b2b = (process.env.VUE_APP_LOGOUT_URL_B2B || "").trim();
  const b2c = (process.env.VUE_APP_LOGOUT_URL_B2C || "").trim();
  return (isB2c ? b2c || b2b : b2b || b2c) || null;
}

function normalizeUrlForCompare(url) {
  const parsed = new URL(url, window.location.origin);
  const stripTrailingSlash = (value) => value.replace(/\/+$/, "");
  const hashPath = parsed.hash.split("?")[0];
  return `${parsed.origin.toLowerCase()}${stripTrailingSlash(parsed.pathname)}${stripTrailingSlash(hashPath)}`;
}

/**
 * True when the given URL points to this app's own login route.
 */
export function isInternalLoginUrl(url) {
  try {
    return normalizeUrlForCompare(url) === normalizeUrlForCompare(buildRouteUrl("login"));
  } catch {
    return false;
  }
}

/**
 * Env LOGOUT_URL_B2B / LOGOUT_URL_B2C login target. B2B is preferred when roleId is unknown.
 * @returns {{ internal: true } | { internal: false, url: string }}
 */
export function getEnvLoginRedirect(roleId) {
  const url = readEnvLogoutUrl(String(roleId) === "1");
  if (!url || isInternalLoginUrl(url)) {
    return { internal: true };
  }
  return { internal: false, url };
}
